<template>
  <div>
    <b-row>
      <div class="col-md-6 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام شرکت:" label-for="example-input-1">
          <b-form-input id="example-input-1" v-model="$v.value.name.$model" :state="validateState('name')"
            :disabled="disabled"></b-form-input>
          <b-form-invalid-feedback v-if="!$v.value.name.required" id="input-1-live-feedback">
            وارد کردن نام شرکت اجباری است
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.name.fachars" id="input-1-live-feedback">
            نام شرکت باید به صورت فارسی وارد شود
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام شرکت به انگلیسی:" label-for="example-input-1">
          <b-form-input id="example-input-1" ref="en_company_name" @keyup="setENChars('en_company_name')"
            :state="validateState('en_company_name')" v-model="$v.value.en_company_name.$model"
            :disabled="disabled"></b-form-input>
          <b-form-invalid-feedback v-if="!$v.value.en_company_name.enchars" id="input-1-live-feedback">نام شرکت را با
            حروف انگلیسی وارد کنید</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>
    <b-row>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <b-form-group id="example-input-group-1" label="شناسه ملی:" label-for="example-input-1">
          <b-form-input id="example-input-1" @keyup="setENChars('com_shenase')" v-model="$v.value.com_shenase.$model"
            :state="validateState('com_shenase')" :disabled="disabled"></b-form-input>
          <b-form-invalid-feedback v-if="!$v.value.com_shenase.required" id="input-1-live-feedback">وارد کردن شناسه ملی
            شرکت اجباری است</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.com_shenase.numbers" id="input-1-live-feedback">شناسه ملی باید
            عدد باشد</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.com_shenase.minLength" id="input-1-live-feedback">حداقل طول
            شناسه ملی باید 8 کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3" :style="{ display: disabled ? 'none' : 'block' }">
        <p>بارگذاری اسکن مجوز کسب و کار:</p>
        <b-row>
          <b-col>
            <FileUploader v-model="$v.value.business_license.$model"></FileUploader>
          </b-col>
          <b-col v-if="
            $v.value.business_license.$model != null &&
            $v.value.business_license.$model.length > 0
          ">
            <b-link v-if="businessLicenseUrl" target="_blank" href="#"
              @click.prevent="httpHelper.getFileUrl($v.value.business_license.$model)">برای مشاهده مدارک کلیک
              کنید</b-link>
          </b-col>
        </b-row>
      </div>
      <div class=" col-md-3 col-sm-3 col-xs-3">
        <b-form-group id="register-input-group-1" label="شماره ثبت:" label-for="register-input-1">
          <b-form-input id="register-input-2" @keyup="setENChars('register_number')"
            v-model="$v.value.register_number.$model" :state="validateState('register_number')"
            :disabled="disabled"></b-form-input>
          <b-form-invalid-feedback v-if="!$v.value.register_number.required" id="input-2-live-feedback">وارد کردن
            شماره
            ثبت شرکت اجباری است</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.register_number.numbers" id="input-2-live-feedback">شماره
            ثبت
            باید عدد باشد</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.register_number.minLength" id="input-2-live-feedback">شماره ثبت
            باید حداقل 4 کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <b-form-group id="date-register-input-group-1" label="تاریخ ثبت:" label-for="date-register-input-1">
          <date-picker clearable required v-model="$v.value.register_date.$model" ref="register_date"
            :disabled="disabled"></date-picker>
          <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن تاریخ تولد اجباری است</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام مدیر:" label-for="example-input-1">
          <b-form-input id="example-input-1" v-model="$v.value.fa_name.$model" ref="fa_name"
            :state="validateState('fa_name')" :disabled="disabled"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.fa_name.required" id="input-1-live-feedback">نام را وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_name.fachars" id="input-1-live-feedback">نام را با حروف فارسی
            وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_name.minLength" id="input-1-live-feedback">نام باید حداقل ۳
            کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام خانوادگی مدیر:" label-for="example-input-1">
          <b-form-input id="example-input-1" v-model="$v.value.fa_family.$model" :state="validateState('fa_family')"
            ref="fa_family" :disabled="disabled"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.fa_family.required" id="input-1-live-feedback">نام خانوادگی را وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_family.fachars" id="input-1-live-feedback">نام خانوادگی را با
            حروف فارسی وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_family.minLength" id="input-1-live-feedback">نام خانوادگی
            باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام پدر مدیر" label-for="example-input-1">
          <b-form-input :disabled="disabled" id="example-input-1" ref="fa_father" :state="validateState('fa_father')"
            v-model="$v.value.fa_father.$model"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.fa_father.required" id="input-1-live-feedback">نام پدر را وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_father.fachars" id="input-1-live-feedback">نام پدر را با حروف
            فارسی وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.fa_father.minLength" id="input-1-live-feedback">نام پدر باید
            حداقل ۳ کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام مدیر به انگلیسی:" label-for="example-input-1">
          <b-form-input id="example-input-1" :disabled="disabled" ref="en_name" v-model="$v.value.en_name.$model"
            :state="validateState('en_name')"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.en_name.required" id="input-1-live-feedback">نام انگلیسی را وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_name.enchars" id="input-1-live-feedback">نام انگلیسی را با
            حروف انگلیسی وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_name.minLength" id="input-1-live-feedback">نام انگلیسی باید
            حداقل ۳ کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام خانوادگی مدیر به انگلیسی:" label-for="example-input-1">
          <b-form-input id="example-input-1" ref="en_family" v-model="$v.value.en_family.$model"
            :state="validateState('en_family')" :disabled="disabled"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.en_family.required" id="input-1-live-feedback">نام خانوادگی انگلیسی
            را وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_family.enchars" id="input-1-live-feedback">نام خانوادگی
            انگلیسی را با حروف انگلیسی وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_family.minLength" id="input-1-live-feedback">نام خانوادگی
            انگلیسی باید حداقل ۳ کاراکتر
            باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="نام پدر مدیر به انگلیسی:" label-for="example-input-1">
          <b-form-input id="example-input-1" :disabled="disabled" ref="en_father" :state="validateState('en_father')"
            v-model="$v.value.en_father.$model"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.en_father.required" id="input-1-live-feedback">نام پدر انگلیسی را
            وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_father.enchars" id="input-1-live-feedback">نام پدر انگلیسی را
            با حروف انگلیسی وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.en_father.minLength" id="input-1-live-feedback">نام پدر انگلیسی
            باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>

    <b-row>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="کد ملی مدیر:" label-for="example-input-1">
          <b-form-input id="example-input-1" v-model="$v.value.national_card_number.$model" :disabled="disabled"
            ref="national_card_number" @keyup="setENChars('national_card_number')"
            :state="validateState('national_card_number')"></b-form-input>

          <b-form-invalid-feedback v-if="!$v.value.national_card_number.required" id="input-1-live-feedback">کد ملی را
            وارد کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.value.national_card_number.numbers" id="input-1-live-feedback">کد ملی فقط
            باید عدد باشد</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.national_card_number.minLength" id="input-1-live-feedback">کد
            ملی باید حداقل 10 کاراکتر باشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="شماره شناسنامه:" label-for="example-input-1">
          <b-form-input id="example-input-100" :disabled="disabled" @keyup="setENChars('id_number')"
            v-model="$v.value.id_number.$model" :state="validateState('id_number')"></b-form-input>
          <b-form-invalid-feedback v-if="!$v.value.id_number.required" id="input-1-live-feedback">شماره شناسنامه را وارد
            کنید</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.id_number.numbers" id="input-1-live-feedback">شماره شناسنامه فقط
            باید عدد باشد</b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.value.id_number.idnumbers" id="input-1-live-feedback">شماره شناسنامه
            عدد 0 نباشد</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="تلفن همراه مدیر:" label-for="example-input-1">
          <b-form-input id="example-input-1" v-model="$v.value.mobile.$model" ref="mobile"
            :state="validateState('mobile')" disabled></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن تلفن همراه اجباری است</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="پست الکترونیکی" label-for="example-input-1">
          <b-form-input disabled id="example-input-1" ref="email" v-model="$v.value.email.$model"
            :state="validateState('email')"></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">پست الکترونیکی اجباری است</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>
    <b-row>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-row>
          <b-col>
            <b-form-group id="example-input-group-1" label="تلفن ثابت:" label-for="example-input-1">
              <b-form-input id="example-input-1" v-model="$v.value.phone.$model" @keyup="setENChars('phone')"
                :state="validateState('phone')" :disabled="disabled"></b-form-input>

              <b-form-invalid-feedback v-if="!$v.value.phone.required" id="input-1-live-feedback">تلفن ثابت را وارد
                کنید</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.value.phone.numbers" id="input-1-live-feedback">تلفن ثابت فقط باید عدد
                باشد</b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.value.phone.minLength" id="input-1-live-feedback">تلفن ثابت باید
                حداقل 5 کاراکتر باشد</b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.value.phone.maxLength" id="input-1-live-feedback">تلفن ثابت باید
                حداکثر 8 کاراکتر باشد</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group id="example-input-group-1" label="کد شهر:" label-for="example-input-1">
              <b-form-input id="example-input-1" v-model="$v.value.pre_phone.$model" @keyup="setENChars('pre_phone')"
                :state="validateState('pre_phone')" :disabled="disabled"></b-form-input>

              <b-form-invalid-feedback v-if="!$v.value.pre_phone.required" id="input-1-live-feedback">کد شهر را وارد
                کنید</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.value.pre_phone.numbers" id="input-1-live-feedback">کد شهر فقط باید عدد
                باشد</b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.value.pre_phone.minLength" id="input-1-live-feedback">کد شهر باید
                حداقل 3 کاراکتر باشد</b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.value.pre_phone.maxLength" id="input-1-live-feedback">کد شهر باید
                حداکثر 3 کاراکتر باشد</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="جنسیت:" label-for="example-input-1">
          <MDDropdown :disabled="disabled" v-bind:group="18" ref="mdid18_gender"
            v-model="$v.value.mdid18_gender.$model"></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن جنسیت اجباری است</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <b-form-group id="example-input-group-1" label="تاریخ تولد:" label-for="example-input-1">
          <date-picker clearable required v-model="$v.value.birth_date.$model" ref="birth_date" :max="maxDate"
            :disabled="disabled"></date-picker>
          <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن تاریخ تولد اجباری است</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  email,
  minLength,
  required,
  maxLength,
} from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import FileUploader from "../../components/fileUploader";
import routesMap from '@/helpers/routesMap'
import httpHelper from "../../helpers/httpHelper";
//const enchars = (value, vm) => !/[^A-Za-z0-9]/.test(value);
const numbers = (value, vm) => !/[^0-9]/.test(value);
const idnumbers = (value, vm) => { return parseInt(value) != 0; }
//const fachars = (value, vm) => /[^A-Za-z0-9]/.test(value);
const enchars = (value, vm) => !/[^A-Za-z\s]/.test(value);
const fachars = (value, vm) => /^[\u0600-\u06FF\s]+$/.test(value);
const phone = (value, vm) => /^0\d{5}/g.test(value) && !/^09/g.test(value);
const mobile = (value, vm) => !/^09{9}/g.test(value);
const prephone = (value, vm) => /0\d{2}/.test(value);
export default {
  mixins: [validationMixin],
  name: "PersonInfo",
  props: ["value", "disabled", "validateInputswatcher"],
  components: {
    MDDropdown,
    FileUploader,
  },
  data() {
    return { maxDate: "", businessLicenseUrl, routesMap, httpHelper };
  },
  validations: {
    value: {
      email: {
        required,
        email,
      },
      name: {
        fachars,
        required,
      },
      en_company_name: {
        enchars,
      },
      com_shenase: {
        required,
        numbers,
        minLength: minLength(8),
      },
      register_number: {
        required,
        numbers,
        minLength: minLength(4),
      },
      register_date: {
        required,
      },
      fa_name: {
        fachars,
        required,
        minLength: minLength(3),
      },
      fa_family: {
        fachars,
        required,
        minLength: minLength(3),
      },
      en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_family: {
        enchars,
        required,
        minLength: minLength(3),
      },
      national_card_number: {
        required,
        numbers,
        minLength: minLength(10),
      },
      id_number: {
        required,
        numbers,
        minLength: minLength(1),
        idnumbers
      },
      mobile: {
        required,
        mobile,
      },
      merchant_type: {
        required,
      },
      pre_phone: {
        required,
        numbers,
        minLength: minLength(3),
        maxLength: maxLength(3),
      },
      business_license: {
        required,
      },
      fa_father: { fachars, required, minLength: minLength(3) },
      en_father: { enchars, required, minLength: minLength(3) },
      phone: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(8),
        numbers,
      },
      mdid18_gender: { required },
      birth_date: { required },
    },
  },
  watch: {
    value: function (newval, oldval) {
    },
    validateInputswatcher: function (newval, oldval) {
      this.validateInputs();
    },
    confirmCodeSelfi(newVal) {
      httpHelper.getImage(newVal).then((res) => {
        this.confirmCodeSelfiUrl = res.result.url
      });
    },
  },
  methods: {
    setENChars(field) {
      this.value[field] = this.value[field].toEnDigits();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.value.$touch();
    },
  },
  created() {
    //this.form = this.value;

    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var c = new Date(year - 18, month, day);
    this.maxDate = persianDate.getDateByFormat(c);
  },
};
</script>
